import { useState } from "react";
import Welcome from "./Welcome";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";

const LOCAL_STORAGE_ITEM_NAME = "kms-live-studio-dont-show-welcome";

/**
 * Handles the display of the Welcome modal according to localStorage
 */
export function StudioWelcomeManager() {
    const sendButtonAnalytics = useButtonAnalytics();
    const [showWelcomeModal, setShowWelcomeModal] = useState(() => {
        const dontShowWelcome = localStorage.getItem(LOCAL_STORAGE_ITEM_NAME) === "true";
        return !dontShowWelcome;
    });

    const handleWelcomeClose = () => {
        sendButtonAnalytics("Close Viewing as Studio modal", ButtonClickAnalyticsType.CLOSE);
        setShowWelcomeModal(false);
    };

    const handleDontShowAgainChange = (dontShowAgain: boolean) => {
        sendButtonAnalytics(
            (dontShowAgain ? "Don't " : "") + "show the Studio view modal",
            ButtonClickAnalyticsType.TOGGLE
        );
        localStorage.setItem(LOCAL_STORAGE_ITEM_NAME, dontShowAgain.toString());
    };

    return (
        <Welcome
            open={showWelcomeModal}
            onClose={handleWelcomeClose}
            onDontShowAgainChange={handleDontShowAgainChange}
            title={translate("Welcome to the Studio")}
            contentText={translate(
                "Prepare and manage your broadcast from here. To see the attendee experience, click the Attendee view button."
            )}
        />
    );
}

export default StudioWelcomeManager;
